<template>
	<div class="saylist">
		<van-action-sheet v-model:show="show" :actions="nlist" @select="onSelect" />
		<div class="a kf" v-if="actkf" @click="sub(actkf)">
			{{ actkf.label }}
		</div>
		<div class="a others" @click='show=true;' v-if='nlist.length>0'>热门问题</div>
	</div>
</template>

<script setup>
	import {ref,defineEmits,computed} from 'vue'
	const emits=defineEmits(['modelsub'])
	import { showToast } from 'vant';
	const lastClickTime = ref(0); // 记录上次点击的时间戳
	import { useSocket } from "@/stores/index";
	const show=ref(false)
	

	const actkf=computed(()=>{
		const list=useSocket().group.robot?.robotQptplPhrases || []
		return list.find(ele=>{return ele.action==3});
	})
	const nlist=computed(()=>{
		const list=useSocket().group.robot?.robotQptplPhrases || []
		return list.filter(ele=>{return ele.action!=3}).map(ele=>{return {
			content:ele.content,
			name:ele.label,
			action:ele.action
		}})
	})
	const onSelect = (item) => {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      show.value = false;
			sub(item);
  };

	const sub=(val)=>{
		const currentTime = Date.now();
		if (currentTime - lastClickTime.value >= 1000) { // 判断是否超过3秒
			emits('modelsub', val);
			lastClickTime.value = currentTime; // 更新上次点击的时间戳
		} else {
			showToast('点击过于频繁，请稍后再试');
		}
	
	}
</script>

<style lang="scss" scoped>
	.saylist {
		// height: 56px;
		overflow-x: auto;
		box-sizing: border-box;
		white-space: nowrap;
		padding: 12px;
		display: flex;
		.a{
			padding: 0 9px;
			height: 30px;
			font-size: 12px;
			min-width: 48px;
			text-align: center;
			color: #6D6E7ee2;
			line-height: 32px;
			border-radius: 8px;
			margin-right: 8px;
			display: inline-block;
			border: 1px solid #eee;
		}
		.kf{
			background: linear-gradient(0deg, #fff 0%, #ffcdcd   100%);
			display: flex;
			cursor: pointer;
			align-items: center;
			width:100px;
			color:#f00;
			&::before{
				width: 16px;
				height:16px;
				background: url('../../assets/images/kf.png') no-repeat;
				background-size: 100% 100%;
				content:'';
				margin-right: 4px;
			}
		}
		.others{
			background:#eee;
			width:80px;
			display: flex;
			align-items: center;
			justify-content: center;
			&::after{
				width: 0px;
				height:0px;
				content:'';
				border-width: 4px;
				border-color:transparent transparent #333;
				border-style:solid;
				margin-top: -4px;
				margin-left:4px;
			}
		}
	}
	.saybox{
		height: 0;
	}
</style>